export { default } from './RelacionatsMarato';
